import React, { Component } from "react";
import { DropzoneDialog } from "material-ui-dropzone";
import PropTypes from "prop-types";
import swal from "sweetalert";
import { superUploadExcel } from "rest/requests";

export default class DropzoneDialogStores extends Component {
  constructor({ props, open, setOpen }) {
    super(props);
    this.open = open;
    this.setOpen = setOpen;
    this.state = {
      files: []
    };
  }

  handleClose() {
    this.setOpen(false);
  }

  handleSave(files) {
    //Saving files to state for further use and closing Modal.
    this.setState({
      files: files
    });

    files.forEach((_file) => {
      const formData = new FormData();
      formData.append("file", _file);
      superUploadExcel(formData)
        .then((req, resp) => {
          console.log(resp);
          swal("Ok", "Archivo cargado exitosamente", "success");
          this.setOpen(false);
        })
        .catch((error) => {
          console.log("Error...", error);
          swal("Oops!", "Algo a salido mal durante el procesamiento", "error");
          this.setOpen(false);
        });
    });
  }

  render() {
    return (
      <div>
        <DropzoneDialog
          open={this.open}
          onSave={this.handleSave.bind(this)}
          acceptedFiles={[".xlsx", ".xls"]}
          showPreviews={true}
          maxFileSize={5000000}
          onClose={this.handleClose.bind(this)}
          dialogTitle="Buscar o arrastrar el archivo"
          submitButtonText="Cargar"
          cancelButtonText="Cancelar"
          dropzoneText="Clic sobre el cuadro para buscar"
        />
      </div>
    );
  }
}

DropzoneDialogStores.defaultProps = {
  props: {},
  open: false,
  setOpen: null,
  year: new Date().getFullYear()
};

DropzoneDialogStores.propTypes = {
  props: PropTypes.object,
  open: PropTypes.bool,
  setOpen: PropTypes.func,
  year: PropTypes.number
};
